<script>
import appConfig from "@/app.config";
import sharedDocumentsApi from "@/services/sharedDocuments-api";
import SharedDocuments from "@/components/sharedDocuments"; 

export default {
    page: {
        title: "Documents Import",
        meta: [{ name: "description", content: appConfig.description }]
    },

    components: {
        SharedDocuments
    },

    mounted(){


    },
    
    data() {
        return {

            uploadedFile: null,
            documentsFile: {name: null, id: null},
            documentsFileImportInProgress: false,
            shareadDocumentType: null,
            documentsTypeOptions: [
                { value: 0, name: "Pack" },
                { value: 1, name: "Catalogue Fournisseur" }
         ],
         sharedDocumentsKey: 0,

        }
    }, 
    methods:{

        cancelEdit() {
            this.documentsFile = {name: null, id: null};
            this.uploadedFile = null;
            this.shareadDocumentType = null;
        },

        editSharedDocument(item) {
            this.documentsFile.id = item.id;
            this.documentsFile.name = item.documentName;
            this.shareadDocumentType = this.documentsTypeOptions.find(opt => opt.value === item.documentType);          
        },


        onDocumentsUpload(){

            this.documentsFileImportInProgress = true;
            
            const fd = new FormData();

            if (this.uploadedFile) {
                fd.append('file', this.uploadedFile);
            }

            if (this.documentsFile && this.documentsFile.name) {
                fd.append('name', this.documentsFile.name);
            }

            if (this.shareadDocumentType && this.shareadDocumentType.value != null) {
                fd.append('type', this.shareadDocumentType.value);
            }

            if (this.documentsFile && this.documentsFile.id) {
                fd.append('id', this.documentsFile.id);
            }

            sharedDocumentsApi.importDocuments(fd).then((result) =>{
                    this.documentsFileImportInProgress = false;
                    if(result) {
                        this.documentsFile= {file: null, name: null, type: null},
                        this.uploadedFile=null,
                        this.sharedDocumentsKey ++;
                    } 

                
              }
            ).finally(() => {
              this.documentsFileImportInProgress = false;
              this.sharedDocumentsKey ++;

            //   this.documentsFile= {file: null, name: null, type: null},
            //   this.uploadedFile=null

            }).catch(() => {
              this.documentsFileImportInProgress = false;
              this.documentsFile= {file: null, name: null, type: null},
              this.uploadedFile=null,
              this.sharedDocumentsKey ++;

        });
        },

    },
}
</script>
<template>

    <div class="p-sm-4">
      <div >
        <div class="row pt-sm-4">
            <div class="col-12">
                <h5 class="text-primary font-size-16"><i class="fas fa-file-archive  mr-2"/><strong>Importer des documents</strong></h5>
            </div>
        </div>


         <div v-if="documentsFile && documentsFile.id == null" class=" custom-input-file-width mt-2 mb-2" > 
                <b-form-group  label-for="">
                    <b-form-file
                        v-model="uploadedFile"
                        ref="fileUpload"
                        placeholder="Aucun fichier sélectionné"
                        drop-placeholder="Placez le fichier ZIP ici"
                    ></b-form-file>
                </b-form-group>
        </div>

        <div class="row pt-2" >
            <div class="col-md-6 col-12"> 
                <div class="custom-input-file-width mr-md-2 mr-0" > 
                    <b-form-group :label="$t('lists.sharedDocument.name')" label-for="">
                        <b-input
                            id="numberInput"
                            type="text"
                            class="form-control text-dark font-weight-normal bg-white"
                            v-model="documentsFile.name"
                            placeholder="Nom du document"
                        />
                    </b-form-group>
                </div>
            </div>
        
            <div class="col-md-6 col-12">  
                <div class="custom-input-file-width ml-md-2 ml-0" > 
                    <b-form-group :label="$t('lists.sharedDocument.filter')" label-for="">
                        <v-select class="style-vselect-big" style="font-size:1.2em;" :options="documentsTypeOptions" :placeholder="$t('lists.sharedDocument.label')" label="name" v-model="shareadDocumentType">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
            </div>

        </div>    

            <div  class="text-right pt-2 ">

                <b-button v-if="documentsFile && documentsFile.id " variant="secondary" size="sm" class="mr-2" @click="cancelEdit()" >                        
                    <span class="font-weight-bold font-size-14 text-uppercase pr-3 pl-3"> Annuler </span>
                </b-button>

                <b-button variant="primary"  @click="onDocumentsUpload" size="sm" :disabled="!documentsFile || documentsFileImportInProgress">                        
                    <b-spinner small :class="this.documentsFileImportInProgress ? 'mr-2' : 'd-none'"></b-spinner>
                    <span class="font-weight-bold font-size-14 text-uppercase pr-3 pl-3">  {{ documentsFile && documentsFile.id == null ? 'Importer' : 'Modifier' }} </span>
                </b-button>
            </div>

            

      </div>

      <SharedDocuments :key="sharedDocumentsKey" @editSharedDocument="editSharedDocument"/>
    </div>

</template>